import { useState } from 'react'

interface Props<Data> {
    initialData: Data
    children: (result: {
        data: Data,
        setData: (data: Data) => void,
    }) => JSX.Element,
}

const WithData = <Data extends unknown>(props: Props<Data>): JSX.Element => {
    const [data, setData] = useState(props.initialData)
    return props.children({ data, setData })
}

export default WithData